import {SettingsStorage} from "./settings-storage.js";


export class CollapseWithStorage {
    selector;
    storageName;

    constructor(selector, storageName) {
        this.selector = selector;
        this.storageName = storageName;
        this.initialize();
    }

    initialize() {
        this.$container = jQuery(this.selector);
        this.settings = new SettingsStorage(this.storageName);
        const collapseId = `${md5(this.selector)}_collapse_opened`;
        if (this.settings.getBoolean(collapseId) === true) {
            this.$container.addClass('show')
        }
        this.$container.on('shown.bs.collapse hidden.bs.collapse', () => {
            this.settings.set(collapseId, this.$container.hasClass('show'));
        });
    }

}
